import React from 'react';
import { Separator } from '@chakra-ui/react';
import { VStack } from '@ayble-health/dashboard-components';
import { UserProfile } from './UserProfile';
import { UserInformation } from '../HealthCoachDashboard/UserInformation';
import { MeetingNotes } from '../HealthCoachDashboard/MeetingNotes';
import styled from '@emotion/styled';
import { UserDashboardSideContentAction } from './UserDashboardSideContentAction';
import { UpcomingMeeting } from './UpcomingMeeting';
import { UserSubscription } from './UserSubscription';
import { UserCareTeam } from './UserCareTeam';

const GradientBox = styled('div')`
  background-image: linear-gradient(to bottom, #ffffff, #ebf5ff, #ebf5ff);
`;

type Props = {
  openHealthieCharting: (chartingNoteUrl?: string | null) => void;
};

export const UserDashboardSideContent = ({ openHealthieCharting }: Props) => {
  return (
    <GradientBox>
      <VStack height={'100%'} p={6}>
        <UserProfile />

        <UpcomingMeeting
          onOpenChartNote={(chartingNoteUrl) => {
            openHealthieCharting(chartingNoteUrl);
          }}
        />

        <UserInformation />

        <UserDashboardSideContentAction
          onClick={() => {
            openHealthieCharting();
          }}
          text={'Charting'}
        />

        <UserCareTeam />

        <Separator mb={3} mt={8} />

        <UserSubscription />

        <Separator mb={3} mt={8} />

        <MeetingNotes onOpenChartNote={openHealthieCharting} />
      </VStack>
    </GradientBox>
  );
};
